import { getFldArea } from "@assets/oilAndGasData/fldArea"
import type { OilAndGasFieldArea } from "@assets/oilAndGasData/types"
import { useAppSelector } from "@redux/app/hooks"
import { getConsumptionMapFiltersOil } from "@redux/features/mapFiltersOil/consumptionMapFiltersOilSlice"
import { getMapFiltersOil } from "@redux/features/mapFiltersOil/mapFiltersOilSlice"
import { useEffect, useState } from "react"

type OilFiltersStorageKey = "mapFiltersOil" | "consumptionMapFiltersOil"

export default function useGetOilGasDataForMap(
	oilFiltersStorageKey: OilFiltersStorageKey = "mapFiltersOil"
): OilAndGasFieldArea[] {
	const defaultMapFiltersOil = useAppSelector(getMapFiltersOil)
	const consumptionMapFiltersOil = useAppSelector(getConsumptionMapFiltersOil)
	const mapFiltersOil =
		oilFiltersStorageKey === "consumptionMapFiltersOil"
			? consumptionMapFiltersOil
			: defaultMapFiltersOil

	const [fieldsData, setFieldsData] = useState<OilAndGasFieldArea[]>([])

	useEffect(() => {
		let shouldIgnore = false
		const fieldFilters = mapFiltersOil.fields
		const facilitiesFilters = mapFiltersOil.facilities

		const fieldTypesToKeep: string[] = []
		if (fieldFilters.showOil === true) {
			fieldTypesToKeep.push("OIL")
		}
		if (fieldFilters.showGas === true) {
			fieldTypesToKeep.push("GAS")
		}
		if (fieldFilters.showOilGas === true) {
			fieldTypesToKeep.push("OIL/GAS")
		}
		if (fieldFilters.showGasCondensate === true) {
			fieldTypesToKeep.push("GAS/CONDENSATE")
		}

		// created by AI: the field polygons are large, so load them only when a map needs them.
		void getFldArea()
			.then((fldArea) => {
				if (shouldIgnore === true) {
					return
				}

				const filteredFieldsData = fldArea.filter(
					(f: OilAndGasFieldArea) => fieldTypesToKeep.includes(f.fldHcType) === true
				)
				setFieldsData(filteredFieldsData)
			})
			.catch((error: unknown) => {
				console.error("Failed to load oil and gas field areas", error)
				if (shouldIgnore === false) {
					setFieldsData([])
				}
			})

		const facilityTypesToKeep: string[] = []
		if (facilitiesFilters.showSurface === true) {
			facilityTypesToKeep.push("Y")
		}
		if (facilitiesFilters.showUnderwater === true) {
			facilityTypesToKeep.push("N")
		}

		return () => {
			shouldIgnore = true
		}
	}, [mapFiltersOil])

	return fieldsData
}
